import React, { useState, useEffect } from 'react'
import "./assets/css/bootstrap.min.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/nice-select.css";
import "./assets/css/magnific-popup.css";
import "./assets/css/slick.css";
import "./assets/css/default.css";
import "./assets/css/style.css";
import useBlogScripts from "./useBlogScripts";
import { Link } from 'react-router-dom';

const trendingNews = [
    { text: "Miranda halim was viral after finish his workout.", href: "#" },
    { text: "Celebrating Asian Pacific American art and cultures", href: "#" },
    { text: "Honoring Asian Pacific American Heritage Month at Google", href: "#" },
];

export default function Header() {
    useBlogScripts();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimate(true);
            setTimeout(() => {
                setCurrentIndex(prev => (prev + 1) % trendingNews.length);
                setAnimate(false);
            }, 500);
        }, 3000);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className='blog_page'>
            <div class="binduz-er-news-off_canvars_overlay"></div>
            <div class="binduz-er-news-offcanvas_menu">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="binduz-er-news-offcanvas_menu_wrapper">
                                <div class="binduz-er-news-canvas_close">
                                    <a href="javascript:void(0)"><i class="fal fa-times"></i></a>
                                </div>
                                <div class="binduz-er-news-header-social">
                                    <ul class="text-center">
                                        <li><a href="#">facebook</a></li>
                                        <li><a href="#">Twitter</a></li>
                                        <li><a href="#">Skype</a></li>
                                    </ul>
                                </div>
                                <div id="menu" class="text-left ">
                                    <ul class="binduz-er-news-offcanvas_main_menu">
                                        <li class="binduz-er-news-menu-item-has-children binduz-er-news-active">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li class="binduz-er-news-menu-item-has-children">
                                            <Link to="#">Author</Link>
                                        </li>
                                        <li class="binduz-er-news-menu-item-has-children">
                                            <Link to="#"> About</Link>
                                        </li>
                                        <li class="binduz-er-news-menu-item-has-children">
                                            <Link to="/contact"> Contact</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div class="binduz-er-news-offcanvas_footer">
                                    <div class="binduz-er-news-logo text-center mb-30 mt-30">
                                        <a href="index.html">
                                            <img src={require('./assets/images/logo.png')} alt="" />
                                        </a>
                                    </div>
                                    <p>I’m Michal Škvarenina, a multi-disciplinary designer currently working at Wild and as a freelance designer.</p>
                                    <ul>
                                        <li><i class="fas fa-phone"></i> +212 34 45 45 98</li>
                                        <li><i class="fas fa-home"></i> Angle Bd Abdelmoumen & rue soumaya, Résidence</li>
                                        <li><i class="fas fa-envelope"></i> hello@example.com</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="binduz-er-news-search-box">
                <div class="binduz-er-news-search-header">
                    <div class="container mt-60">
                        <div class="row">
                            <div class="col-6">
                                <img src={require('./assets/images/logo-4.png')} alt="" />
                            </div>
                            <div class="col-6">
                                <div class="binduz-er-news-search-close float-end">
                                    <button class="binduz-er-news-search-close-btn">Close <span></span><span></span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="binduz-er-news-search-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="binduz-er-news-search-form">
                                    <form action="#">
                                        <input type="text" placeholder="Search for Products" />
                                        <button><i class="fa fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <header class="binduz-er-header-area">
                <div class="binduz-er-header-nav">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="navigation">
                                    <nav class="navbar navbar-expand-lg mb-0">
                                        <div class="navbar-brand logo"><Link to="/"><img src={require('./assets/images/logo.png')} alt="" /></Link></div>
                                        <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                                            <ul class="navbar-nav m-auto">
                                                <li class="nav-item active">
                                                    <Link class="nav-link" to="/">Home</Link>
                                                </li>
                                                <li class="nav-item">
                                                    <Link class="nav-link" to="/blog/author">Author</Link>
                                                </li>
                                                <li class="nav-item">
                                                    <Link class="nav-link" to="#">About</Link>
                                                </li>
                                                <li class="nav-item">
                                                    <Link class="nav-link" to="/contact">Contact</Link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="binduz-er-navbar-btn d-flex">
                                            <div class="binduz-er-widget d-flex">
                                                <a class="binduz-er-news-search-open" href="#"><i class="far fa-search"></i></a>
                                                <a href="#"><i class="far fa-user"></i></a>
                                            </div>
                                            <span class="binduz-er-toggle-btn binduz-er-news-canvas_open d-block d-lg-none">
                                                <i class="fal fa-bars"></i>
                                            </span>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}
